import { Injectable } from '@angular/core';
import { InputTextRenderer } from 'src/app/shared/renderers/input-text/input-text.component';
import { DuplicateButtonRenderer } from 'src/app/shared/renderers/duplicate-button/duplicate-button.component';
import { InputTextDatasetRenderer } from 'src/app/shared/renderers/input-text/input-text-dataset/input-text-dataset.component';
import { ERAPecEccAquaticLogicService } from '../../era-pec-ecc-aquatic/services/era-pec-ecc-aquatic.logic.service';

@Injectable({
  providedIn: 'root',
})

export class ERAPecEccPlantAssessmentToolWpezUsColDef {

  constructor(private readonly logicService: ERAPecEccAquaticLogicService) {}

  public getColumnsDefinition(isProjectOwnershipValid: boolean){

    return [
      {
        headerName: 'ERA SME Selection',
        pinned: true,
        checkboxSelection: isProjectOwnershipValid,
        editable: false,
        width: 117,
        sortable: true,
        field: 'eraSmeSelection',
        hide: !isProjectOwnershipValid,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          show: false
        }
      },
      {
        headerName: 'EEA SME Selection',
        editable: false,
        field: 'eeaSmeSelection',
        type: 'selected',
        resizable: true,
        width: 95,
        wrapText: true,
        pinned: true,
        sortable: true,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          instance: this,
          columnThatModifies: 'eeaSmeSelection',
          disabled: true
        }
      },
      {
        headerName: 'Data Set',
        field: 'dataSet',
        width: 160,
        cellRenderer: InputTextDatasetRenderer,
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Substance',
        field: 'substance',
        width: 150,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.substances,
            optionValue: 'optionValue',
            optionLabel: 'optionLabel',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Application Scheme',
        field: 'applicationScheme',
        width: 250,
        cellRenderer: InputTextRenderer,
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'Crop',
        field: 'crop',
        width: 155,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.crops,
            optionValue: 'optionValue',
            optionLabel: 'optionValue',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          };
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },

      {
        headerName: 'Region',
        field: 'region',
        width: 110,
        cellRenderer: 'dropdownlistRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            options: this.logicService.scenarios.filter(scenario => scenario.crop === data.crop),
            optionValue: 'region',
            optionLabel: 'region',
            filterable: true,
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: 'left'
      },
      {
        headerName: 'WPEZ (lb/A)',
        field: 'wpezlba',
        width: 115,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams:  (params: any) => {
          const data = params?.data;
          return {
            field: 'wpezlba',
            maxDecimals: 7,
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          }
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'WPEZ (kg/ha)',
        field: 'wpezkgha',
        width: 120,
        cellRenderer: 'inputNumberRenderer',
        cellRendererParams: {
            field: 'wpezkgha',
            maxDecimals: 7,
            disabled: true,
        },
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '',
        colId: 'duplicate',
        field: 'duplicateButton',
        cellRenderer: DuplicateButtonRenderer,
        type: 'rightAligned',
        width: 130,
        cellRendererParams: (params: any) =>{
          const data = params?.data;
            return {
              disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
              mainTablePkName: "resultSurfaceWaterPk"
            }
        }
      },
      {
        headerName: '',
        width: 125,
        minWidth: 125,
        editable: false,
        colId: 'action',
        cellRenderer: 'deleteButtonRenderer',
        cellRendererParams: (params: any) => {
          const data = params?.data;
          return {
            disabled: this.logicService.isDataFromRun( data, data?.runPk  ) || !isProjectOwnershipValid,
          }
        },
        type: 'rightAligned',
      }
    ];
  }
}
